<h1 mat-dialog-title>Select object image</h1>
<button mat-icon-button button (click)="closeDialog()" class="close-icon">
  <mat-icon>close</mat-icon>
</button>
<div class="table-filter">
  <mat-form-field floatPlaceholder="never" class="form-field">
    <mat-icon matPrefix class="icon">search</mat-icon>
    <input class="input" matInput placeholder="Search" [value]="searchWord" (keyup)="filterImages($event)"/>
    <button class="button" mat-button *ngIf="searchWord && searchWord.length" matSuffix matTooltip="Clear"
            (click)="clearFilter()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
<mat-dialog-content>
  <ul class="mesh-list">
    <li class="upload-image">
      <label class="image-button-wrapper">
        {{ 'configurations-fields.UploadButton' | translate}}
        <input type='file' accept="image/*" id="imgInp" (change)="openDialog($event)"/>
        <img src="#" alt="your image"/>
      </label>
    </li>
    <li *ngFor="let image of localImages" (click)="selectedImage = image" [ngClass]="{active: selectedImage === image}">
      <img src="{{ image.Url }}" alt="{{ image.Name }}">
      <p>{{ image.Name }}</p>
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'system.cancel' | translate }}</button>
  <!-- Can optionally provide a result for the closing dialog. -->
  <button mat-button color="primary" [mat-dialog-close]="selectedImage" [disabled]="!selectedImage">
    {{'system.select' | translate}}
  </button>
</mat-dialog-actions>
